import { UncontrolledTooltip, UncontrolledTooltipProps } from 'reactstrap';
import React, { useMemo } from 'react';
import uniqueId from 'lodash/uniqueId';

export interface InfoTooltipProps
  extends Pick<UncontrolledTooltipProps, 'placement'> {
  text: string;
  className?: string;
  size?: number;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  text,
  placement,
  className,
  size = 16,
}) => {
  const icon = require(`@src/assets/images/icons/ic_tooltip.svg`).default;
  const tooltipId = useMemo(() => uniqueId('info-tooltip-'), []);

  return (
    <div className={className}>
      <img src={icon} width={size} height={size} id={tooltipId} alt="" />
      <UncontrolledTooltip placement={placement || 'top'} target={tooltipId}>
        {text}
      </UncontrolledTooltip>
    </div>
  );
};
